/**
 * @generated SignedSource<<41a7a750454bde8bcb350f9067a0e6c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedSettingsSshKeysPageQuery$variables = {
  projectId: Branded<string, 'ProjectId'>;
};
export type SharedSettingsSshKeysPageQuery$data = {
  readonly getProjectSshKeys: {
    readonly " $fragmentSpreads": FragmentRefs<"SharedSettingsSshKeysTableFragment">;
  } | null | undefined;
};
export type SharedSettingsSshKeysPageQuery = {
  response: SharedSettingsSshKeysPageQuery$data;
  variables: SharedSettingsSshKeysPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "projectId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedSettingsSshKeysPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProjectSshKeys",
        "kind": "LinkedField",
        "name": "getProjectSshKeys",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SharedSettingsSshKeysTableFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SharedSettingsSshKeysPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProjectSshKeys",
        "kind": "LinkedField",
        "name": "getProjectSshKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSshKey",
            "kind": "LinkedField",
            "name": "sshKey",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "encrypted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicKey",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "691adef6c238b97699b908645034c3fd",
    "id": null,
    "metadata": {},
    "name": "SharedSettingsSshKeysPageQuery",
    "operationKind": "query",
    "text": "query SharedSettingsSshKeysPageQuery(\n  $projectId: ProjectId!\n) {\n  getProjectSshKeys(projectId: $projectId) {\n    ...SharedSettingsSshKeysTableFragment\n  }\n}\n\nfragment SharedSettingsSshKeysTableFragment on ProjectSshKeys {\n  sshKey {\n    name\n    encrypted\n    publicKey\n  }\n}\n"
  }
};
})();

(node as any).hash = "39d2062af5df8257c4e9a8318bbd4603";

export default node;
